/* eslint eol-last: ["error", "never"] */
export default {
    loading: false,
    ofertanteslist: true,
    ofertantesadd: false,
    ofertantes: [],
    documentos: [],
}